import { Observable, take } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { PopupType } from "src/app/shared/enums/popup-types";
import { Package } from "src/app/shared/types/contract-types";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ContractService } from "src/app/shared/services/contract.service";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PackageService } from "src/app/shared/services/package.service";
import { DomainNameValidators } from "src/app/shared/validators/domain-name.validator";

@Component({
  selector: "app-contract-domain",
  templateUrl: "./contract-domain.component.html",
  standalone: false,
})
export class ContractDomainComponent implements OnInit {
  @Input() contractId!: number;
  @Output() closeForm = new EventEmitter<null>();

  public options$!: Observable<Package[]>;

  approveForm!: FormGroup;
  isLoadingInstance = false;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private packageService: PackageService,
    private contractService: ContractService,
    private domainValidators: DomainNameValidators,
  ) {}

  ngOnInit(): void {
    this.options$ = this.packageService.getDefaultPackage();
    this.approveForm = this.fb.group({
      domainName: [
        "",
        [Validators.required, DomainNameValidators.patternValidator()],
      ],
      tier: ["", Validators.required],
    });
    this.options$.pipe(take(1)).subscribe((options) => {
      if (options?.length) {
        this.approveForm.get("tier")?.setValue(options[options.length - 1].id);
      }
    });
  }

  validateDomain() {
    const control = this.approveForm.get("domainName");
    if (!control)
      return;

    control.setAsyncValidators(
      this.domainValidators.domainAvailabilityValidator(),
    );
    control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }

  submitApproveForm(): void {
    if (this.approveForm.valid) {
      this.isLoadingInstance = true;
      const approveSubscription = this.contractService
        .approveContract(
          this.contractId,
          this.approveForm.value.domainName,
          this.approveForm.value.tier,
        )
        .subscribe(() => {
          approveSubscription.unsubscribe();
          showMessage(PopupType.Success, "Successfuly approved");
          this.approveForm.reset();
          this.isLoadingInstance = false;
          this.closeForm.emit();
        });
    }
    else {
      this.approveForm.markAllAsTouched();
    }
  }

  closeModal() {
    this.closeForm.emit();
  }
}
